import { render, staticRenderFns } from "./CgvGiftBox.vue?vue&type=template&id=396fd0b1&"
import script from "./CgvGiftBox.vue?vue&type=script&lang=js&"
export * from "./CgvGiftBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports